"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INDIGO_EXPLORER_TEMPLATES = exports.INDIGO_RESEARCHER_TEMPLATES = exports.INDIGO_INNOVATOR_TEMPLATES = void 0;
exports.INDIGO_INNOVATOR_TEMPLATES = {
    'Checkpoint 1: Foundations Module': [
        {
            type: 'p',
            children: [
                { text: 'Meet & Greet', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true },
            ],
            id: '5euu1',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Introduce yourself to the student! ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Share what you love about your field and why you enjoy working with Indigo students.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'pmvwn',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Get to know the student,',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: ' inquiring about their research interests, motivations, and background. ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'rc1j9',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Use these questions as a guide, and record their answers in your session notes:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: '690q6',
        },
        {
            type: 'p',
            listStyleType: 'decimal',
            indent: 1,
            children: [
                {
                    text: 'What excites them about your field? ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: '7z3nf',
        },
        {
            type: 'p',
            listStyleType: 'decimal',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Does the student have goals regarding their final project or publication?',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: '95f1l',
        },
        {
            type: 'p',
            listStyleType: 'decimal',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Do they already have any writing or data that they’d like to build on, or are they starting from scratch?',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: '16205',
        },
        {
            type: 'p',
            listStyleType: 'decimal',
            indent: 1,
            listStart: 4,
            children: [
                {
                    text: 'If the student is interested in collecting data, do they already have the necessary space, equipment, and ethical permissions necessary to do so?',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'bhz8j',
        },
        {
            type: 'p',
            listStyleType: 'decimal',
            indent: 1,
            listStart: 5,
            children: [
                {
                    text: 'Does the student have any skills that may aid their research in your field (e.g., stats, coding languages)?',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'ceqoe',
        },
        {
            type: 'p',
            listStyleType: 'decimal',
            indent: 1,
            listStart: 6,
            children: [
                {
                    text: 'How comfortable is your student writing and speaking in English?',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: '5uddx',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                { text: 'Review our ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true },
                {
                    type: 'a',
                    url: 'https://indigo-studiopresto-dev.webflow.io/academic-honor-code-students-parents',
                    target: '_blank',
                    children: [
                        {
                            text: 'Honor Code',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                            bold: true,
                        },
                    ],
                    id: 'spe59',
                },
                { text: ' and ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true },
                {
                    type: 'a',
                    url: 'https://indigo-studiopresto-dev.webflow.io/gpt-policy',
                    target: '_blank',
                    children: [
                        {
                            text: 'GPT Policy',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                            bold: true,
                        },
                    ],
                    id: 'geb9o',
                },
                { text: '.', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true },
                {
                    text: ' Ask your student and their parent or guardian to please sign our honor code before your next meeting.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                { text: '\n' },
            ],
            id: '9gavo',
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Foundations Module',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'h9gem',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Ask if the student needs help accessing our Foundations Module. ',
                    fontSize: '11.5pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'kq85y',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'If the student needs technical assistance, please use a minute of your session to email ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: 'hello@indigoresearch.org',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(17, 85, 204)',
                    underline: true,
                },
                { text: '.', fontSize: '11.5pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
            ],
            id: '2sjek',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                { text: 'Alternatively, go through ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/presentation/d/1qPfkJVK9j-fe9rgL_zPKkTwUg5fHxVukxKJfZAAQ6rs/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: 'this powerpoint version',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'w0fg2',
                },
                { text: ' with them.', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
            ],
            id: 'co09q',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Assign our asynchronous Foundations Module as homework.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: '4mhzw',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Check in with your student after they’ve watched or read the Module, using these questions:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'bu69o',
        },
        {
            type: 'p',
            listStyleType: 'decimal',
            indent: 1,
            children: [
                {
                    text: 'Did they download Zotero? Did they install the browser and word processor plugins? Explore the app together, making sure that the student understands its basic functions.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'wf51c',
        },
        {
            type: 'p',
            listStyleType: 'decimal',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Do they have any questions about citations or scholarly sources?',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'wqt5k',
        },
        {
            type: 'p',
            listStyleType: 'decimal',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Do they have any questions more generally?',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'drj2m',
        },
        {
            type: 'p',
            listStyleType: 'decimal',
            indent: 1,
            listStart: 4,
            children: [
                {
                    text: 'What surprised them about the process of scholarly research?',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'ohelt',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'If it appears that the student did not absorb much of the Foundations Module, ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                { text: 'use ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/presentation/d/1qPfkJVK9j-fe9rgL_zPKkTwUg5fHxVukxKJfZAAQ6rs/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: 'the powerpoint version',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'i2gy5',
                },
                {
                    text: ' to review some of the basics with them on your call.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'lc0up',
        },
        { type: 'p', children: [{ text: '' }], id: 'vyk0a' },
        { type: 'p', children: [{ text: '' }] },
    ],
    'Checkpoint 2: Defining Your Research': [
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Set these expectations with your student:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Their Indigo project will conclude with a concrete outcome, such as a final paper.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'You will work together to share their research with a scholarly community through a journal, competition, conference, or alternative publication venue.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'You will agree on a research topic early on, but the research question may grow more specific and nuanced over the course of your collaboration.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Explore potential Indigo Project Outcomes!',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                { text: 'Look through our ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/spreadsheets/d/1Ht9-Ju2JTNSPB1BvMWghV-voMRNFCTsrCNRIjmGRDFc/edit#gid=0',
                    target: '_blank',
                    children: [
                        {
                            text: 'Publication Venue Database',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                },
                {
                    text: ' to see a selection of the scholarly conversations the student could enter.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                { text: 'Skim our ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/spreadsheets/d/1Ht9-Ju2JTNSPB1BvMWghV-voMRNFCTsrCNRIjmGRDFc/edit#gid=0',
                    target: '_blank',
                    children: [
                        {
                            text: 'Project Database',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                },
                {
                    text: ' of past students’ work for inspiration.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                { text: 'Peruse our ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/spreadsheets/d/1Np_hTMa7kdCXFEZhaNqqo_vOcBDKA5h_qugZPgGqucc/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: 'Research Question Database',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                },
                {
                    text: ' to learn about the scope and form of a research question in your field.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Agree on a realistic project outcome as well as a preliminary question or topic.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 4,
            children: [
                {
                    text: 'Best Practices:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Don’t agree to a topic or research outcome that will require the student to gain access to facilities, equipment, and/or a skill set that is not realistic.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'If you select a question from our Database, email ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: 'hello@indigoresearch.org',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(17, 85, 204)',
                    underline: true,
                },
                { text: '.', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'If the student uses GPT or our database to find a question, they will still have to make that question their own, revising it to fit their research interests as they learn more.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        { type: 'p', children: [{ text: '' }] },
    ],
    'Checkpoint 3: Organising the Research Process': [
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Make sure that the student has downloaded ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    type: 'a',
                    url: 'https://www.zotero.org',
                    target: '_blank',
                    children: [
                        {
                            text: 'Zotero',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                            bold: true,
                        },
                    ],
                },
                { text: ':', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true },
                { text: ' ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Confirm that they have the app, the web plugin, and the word processor plugin. ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'They should also create an online Zotero account as a back-up.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Use Zotero to teach the following practices, ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'which the student will have encountered in our Foundations Module.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Scholarly citations:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: ' why they are important, how to generate them (in the app and in a word processor), and which style to use in your field.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Highlighting and annotating',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                { text: ' articles in the app.', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Taking thorough notes, ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'including page numbers for each idea recorded.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [
                { text: 'Paraphrasing', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true },
                {
                    text: ' material from the student’s notes, synthesizing that they read in their own words.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Practice finding sources on Google Scholar and JSTOR together.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 4,
            children: [
                {
                    text: 'Guide the student to use our ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1v1pEk65wxzz5BMtFnxcLM7ianXCEkodhRWn7JsHKlUo/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: 'Annotated Bibliography Template',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                            bold: true,
                        },
                    ],
                },
                {
                    text: ' to organise their key sources, synthesize their ideas, and practice paraphrasing. To get started…',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                { text: 'Explorers ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true },
                {
                    text: 'should find and analyse 5+ sources.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                { text: 'Researchers', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true },
                {
                    text: ' should find and analyse 10+ sources.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            children: [
                { text: 'Innovators ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true },
                {
                    text: 'should find and analyse 15+ sources.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            indent: 2,
            listStyleType: 'disc',
        },
        { type: 'p', children: [{ text: '' }] },
    ],
    'Checkpoint 4: Resource Access': [
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Make sure that the student has downloaded ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    type: 'a',
                    url: 'https://www.zotero.org',
                    target: '_blank',
                    children: [
                        {
                            text: 'Zotero',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                            bold: true,
                        },
                    ],
                },
                { text: ':', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true },
                { text: ' ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Confirm that they have the app, the web plugin, and the word processor plugin. ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'They should also create an online Zotero account as a back-up.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Use Zotero to teach the following practices, ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'which the student will have encountered in our Foundations Module.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Scholarly citations:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: ' why they are important, how to generate them (in the app and in a word processor), and which style to use in your field.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Highlighting and annotating',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                { text: ' articles in the app.', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Taking thorough notes, ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'including page numbers for each idea recorded.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [
                { text: 'Paraphrasing', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true },
                {
                    text: ' material from the student’s notes, synthesizing that they read in their own words.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Practice finding sources on Google Scholar and JSTOR together.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 4,
            children: [
                {
                    text: 'Guide the student to use our ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1v1pEk65wxzz5BMtFnxcLM7ianXCEkodhRWn7JsHKlUo/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: 'Annotated Bibliography Template',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                            bold: true,
                        },
                    ],
                },
                {
                    text: ' to organise their key sources, synthesize their ideas, and practice paraphrasing. To get started…',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                { text: 'Explorers ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true },
                {
                    text: 'should find and analyse 5+ sources.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                { text: 'Researchers', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true },
                {
                    text: ' should find and analyse 10+ sources.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            children: [
                { text: 'Innovators ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true },
                {
                    text: 'should find and analyse 15+ sources.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            indent: 2,
            listStyleType: 'disc',
        },
        { type: 'p', children: [{ text: '' }] },
    ],
    'Checkpoint 5: Crafting Your Abstract or Prospectus': [
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Choose an Abstract or Prospectus Checklist,',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: ' make a copy, and edit that copy to fit your student’s project. ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                { text: '' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1vqyY8ZIvTjqAITMGHH2KhC5LczTjktB0BKofMI7Csxw/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: 'Humanities & Social Sciences Abstract Checklist',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                },
                { text: '' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                { text: '' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1WCNQO60FTzQ8AL0Yq462iiVXDlXKaXYdCsVwKtaFO04/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: 'Review Paper Abstract Checklist',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                },
                { text: '' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                { text: '' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1RsVkVrgwtN0nq7IZcad0-YSIJ3pw34UAnnsSVKpiKq8/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: 'Empirical Paper Abstract Checklist',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                },
                { text: '' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [
                { text: '' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1lFmNlYaRDqIEsFy58sqxvzWHxfc744bU4G0P18IKSwY/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: 'Qualitative Research Prospectus Checklist',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                },
                { text: '' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 5,
            children: [
                { text: '' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/14XC2hVlRM4MIpr5PJeWzzl29Hopfs5yZZZekCMEJoMA/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: 'Quantitative Research Prospectus Checklist',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                },
                { text: '' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Share your edited template with us',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: ' so that other students in your field can benefit from it.  (',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: 'hello@indigoresearch.org',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(17, 85, 204)',
                    underline: true,
                },
                { text: ')', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Frame the abstract or prospectus as a draft.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: ' Use it as a teaching tool, to set the expectation that your student will iteratively revise their project.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Guide your student to write strategically,',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: ' building on the ideas that they synthesized in their bibliography.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            indent: 1,
            listStyleType: 'disc',
            listStart: 4,
        },
        { type: 'p', children: [{ text: '' }] },
    ],
    'Checkpoint 6: Creating an Outline': [
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Choose one of Indigo’s outline templates.',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                { text: '' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/14RnoZjOi8OUx0nb_6OshGdQkmMi1pXugoFzW0Ql_NeA/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: ' Review Paper Outline Template',
                            fontSize: '11pt',
                            backgroundColor: 'rgb(255, 255, 255)',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                },
                { text: '' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                { text: '' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/13ueWS5n2x2o1fi9MKRjncJRvbjOSXOXdbhtF_Oo8Zdg/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: ' Empirical Paper Outline Template',
                            fontSize: '11pt',
                            backgroundColor: 'rgb(255, 255, 255)',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                },
                { text: '' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                { text: '' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1PysEd6Lx_yEkQ2inLogSFdQT-jhD7FX5lsBkvAU31xc/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: ' Humanities & Social Sciences Outline Template',
                            fontSize: '11pt',
                            backgroundColor: 'rgb(255, 255, 255)',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                },
                { text: '' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [
                { text: '' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1K4cusolxwYmYhRTaM31iWL-73LN38E0lgpdKk_rnhaI/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: ' Blog Post & Science Communication Article Outline Template',
                            fontSize: '11pt',
                            backgroundColor: 'rgb(255, 255, 255)',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                },
                { text: '' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 5,
            children: [
                { text: '' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1P5VMLlQQ9HoUU1ZiCOC_Y2Og_vJidft56qrGFaLUE0w/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: ' Short Academic Paper (1000-2000 words) Outline Template',
                            fontSize: '11pt',
                            backgroundColor: 'rgb(255, 255, 255)',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                },
                { text: '' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Make a copy, edit it to fit your field, and customise it to fit the student’s project.',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'For projects with a creative outcome (e.g., a portfolio, invention, or creative writing) create your own outline.',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Consider sharing your customised outline with the Indigo team (',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: 'hello@indigoresearch.org',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(17, 85, 204)',
                    underline: true,
                },
                { text: '). ', fontSize: '11pt', backgroundColor: 'rgb(255, 255, 255)', color: 'rgb(0, 0, 0)' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Review the outline with your student,',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: ' answer their questions, and agree on a timeline for them to work on this portion of the project.',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'For empirical papers, ',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'guide the student to begin their data collection.',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            indent: 1,
            listStyleType: 'disc',
            listStart: 4,
        },
        { type: 'p', children: [{ text: '' }] },
    ],
    'Checkpoint 7: First Draft Development': [
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Plan ahead, and agree on incremental due dates.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Best practices to support the student’s writing process:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Offer iterative comments using Indigo’s ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1u2Q0w3_-Sx733FrhxHq-IcLmkHMvMgX4r04WXzdYnOA/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: 'Partial Draft Feedback Form',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                },
                { text: '. ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'For guidance on overcoming challenges related to language, scheduling, motivation, or confidence, see our ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1EIC1_WKnOjUYfmBvh5_yq7JWRBkR1vLBp8rMqXCn9lM/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: 'Mentor Handbook',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                },
                { text: ' FAQ section.', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                { text: 'Email ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
                {
                    text: 'hello@indigoresearch.org',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(17, 85, 204)',
                    underline: true,
                },
                {
                    text: ' to seek a writing tutor or request pedagogical support from our Curriculum Lead.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'If your student is writing an empirical paper, this “first draft” will be a partial draft. ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'The student should draft their  introduction and methods sections. ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Ask the student to write a lab report or share written notes on their data collection. ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Teach your student about data analysis.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [
                {
                    text: 'To pass this checkpoint, your student should complete (or nearly complete) their data collection and be prepared to begin their analysis.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 4,
            children: [
                {
                    text: 'Guide the student to adhere to Indigo’s ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    type: 'a',
                    url: 'https://indigo-studiopresto-dev.webflow.io/academic-honor-code-students-parents',
                    target: '_blank',
                    children: [
                        {
                            text: 'Honor Code',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                            bold: true,
                        },
                    ],
                },
                { text: ' and', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true },
                {
                    type: 'a',
                    url: 'https://indigo-studiopresto-dev.webflow.io/gpt-policy',
                    target: '_blank',
                    children: [
                        {
                            text: ' GPT Policy',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                            bold: true,
                        },
                    ],
                },
                {
                    text: ' while writing.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'They should be citing their sources as they go.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Assess their ability to paraphrase. Make sure they are not copy/pasting language, changing two words, and calling it paraphrasing.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Assume that any errors are due to inexperience, and help the student learn from their mistakes.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        { type: 'p', children: [{ text: '' }] },
    ],
    'Checkpoint 8: Completing the Full Draft': [
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Plan ahead, and agree on incremental due dates.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'cjmy8',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Select a feedback form and discuss comments.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'ru8px',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: '',
                },
                {
                    target: '_blank',
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1gDVjGhHA1snbz_f0E_iOPGthmW9dPMFirU02qepolLA/edit?usp=sharing',
                    children: [
                        {
                            text: 'Feedback Form for Qualitative Papers with a Thesis (Humanities & Social Sciences)',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'o30j5',
                },
                {
                    text: '',
                },
            ],
            id: 'b8qek',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: '',
                },
                {
                    target: '_blank',
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1GxzXEHnsefx8ttIMUi4vjDZoDMLxRKoloFEEDrwc8vc/edit?usp=sharing',
                    children: [
                        {
                            text: 'Feedback Form for Review Papers',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'rzjnh',
                },
                {
                    text: '',
                },
            ],
            id: 'v9z2i',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: '',
                },
                {
                    target: '_blank',
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1GSuZ1TQd_yGGuM2S9p7p0xWFriAe7Ix6yE7dNAAiHsE/edit?usp=sharing',
                    children: [
                        {
                            text: 'Feedback Form for Empirical Papers',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: '8y6m0',
                },
                {
                    text: '',
                },
            ],
            id: 'm6gwg',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [
                {
                    text: '',
                },
                {
                    target: '_blank',
                    type: 'a',
                    url: 'https://docs.google.com/document/d/17858NhyJCQC1PkTGc-xmimDMGYJ_FpFO3rA97oasAtc/edit?usp=sharing',
                    children: [
                        {
                            text: 'Feedback Form for Blog Posts & Science Communication Articles',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'v53c2',
                },
                {
                    text: '',
                },
            ],
            id: 'a77xk',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Prepare to discuss multiple drafts!',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: ' Teach your student to revise iteratively, so that they are ready for the publication process.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'gz2he',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 4,
            children: [
                {
                    text: 'For students writing empirical papers, now is the time to finish a full draft. ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'ck5gi',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Guide the student through the process of analyzing their data.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: '26w0j',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Teach the student how to create figures.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'fqdi4',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Ask the student to write their results, discussion, and conclusion sections.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'xdthn',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [
                {
                    text: 'Have the student revise their abstract to reflect their results.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'z59d5',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 5,
            children: [
                {
                    text: 'Academic Integrity Guidelines:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: '7sxoh',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Remind the student to cite their sources as they write.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: '6a45w',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Run the draft through ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    target: '_blank',
                    type: 'a',
                    url: 'https://originality.ai',
                    children: [
                        {
                            text: 'Originality',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: '2x6av',
                },
                {
                    text: ', and discuss the results with your student so that they can correct any citation or paraphrasing mistakes. Confirm that your student has not used generative AI to draft any of their paper, as per ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    target: '_blank',
                    type: 'a',
                    url: 'https://indigo-studiopresto-dev.webflow.io/academic-honor-code-students-parents',
                    children: [
                        {
                            text: 'Indigo’s Honor Code',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: '67q2c',
                },
                {
                    text: ' and ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    target: '_blank',
                    type: 'a',
                    url: 'https://indigo-studiopresto-dev.webflow.io/gpt-policy',
                    children: [
                        {
                            text: 'GPT Policy',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'elj42',
                },
                {
                    text: '.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'l614s',
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: 'Username: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    target: '_blank',
                    type: 'a',
                    url: 'mailto:hello@indigoresearch.org',
                    children: [
                        {
                            text: 'hello@indigoresearch.org',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'a753q',
                },
                {
                    text: '',
                },
            ],
            id: 'b3zho',
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            listStart: 2,
            children: [
                {
                    text: 'Password: IRIS2024!',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(34, 34, 34)',
                },
            ],
            id: 'ys5np',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'If the student is struggling, dedicate at least 30 minutes to reviewing these skills.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'adm0w',
        },
        {
            type: 'p',
            children: [
                {
                    text: '',
                },
            ],
            id: '2ostb',
        },
        {
            type: 'p',
            children: [
                {
                    text: '',
                },
            ],
        },
    ],
    'Checkpoint 9: Revision and Finalisation': [
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Plan ahead, and agree on incremental due dates.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'mf6dd',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Read and revise the paper from start to finish: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'ucjck',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Guide the student to edit the abstract and select keywords.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'tdo85',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: "Finalise the paper's title.",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'avkef',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Review the acknowledgements section.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'vz0ud',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [
                {
                    text: 'Confirm that the Works Cited or Bibliography are in good shape.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: '16vkl',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 5,
            children: [
                {
                    text: 'Run the draft through ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    target: '_blank',
                    type: 'a',
                    url: 'https://originality.ai',
                    children: [
                        {
                            text: 'Originality',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'z08lw',
                },
                {
                    text: ', and discuss the results with your student so that they can correct any citation or paraphrasing mistakes.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: '5iph0',
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: 'Username: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    target: '_blank',
                    type: 'a',
                    url: 'mailto:hello@indigoresearch.org',
                    children: [
                        {
                            text: 'hello@indigoresearch.org',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'mhagc',
                },
                {
                    text: '',
                },
            ],
            id: 'cey1j',
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            listStart: 2,
            children: [
                {
                    text: 'Password: IRIS2024!',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(34, 34, 34)',
                },
            ],
            id: 'px7cs',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Select a feedback form, make a copy, fill it out, and discuss your comments.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: '1outz',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: '',
                },
                {
                    target: '_blank',
                    type: 'a',
                    url: 'https://docs.google.com/document/d/178SIPleo3cO0zwNxY-kYeRfyGfZ6YlNajcfG6slrBCs/edit?usp=sharing',
                    children: [
                        {
                            text: 'Explorer Final Draft Feedback Form',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'ka5rx',
                },
                {
                    text: '',
                },
            ],
            id: 'oatpd',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: '',
                },
                {
                    target: '_blank',
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1blQMKmupC6yJeNn3EkdpmmsgZV-YrXp4UEqz1aYZWx4/edit?usp=sharing',
                    children: [
                        {
                            text: 'Researcher Final Draft Feedback Form',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'qeosx',
                },
                {
                    text: '',
                },
            ],
            id: 'fsrct',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: '',
                },
                {
                    target: '_blank',
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1kabOY9-oBzDdl1v5JjgUOfw-b79C-4Fx97OJCqLPfrw/edit?usp=sharing',
                    children: [
                        {
                            text: 'Innovator Final Draft Feedback Form',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'd3vmk',
                },
                {
                    text: '',
                },
            ],
            id: 'xg0m6',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 4,
            children: [
                {
                    text: 'Go through ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    target: '_blank',
                    type: 'a',
                    url: 'https://docs.google.com/spreadsheets/d/1Ht9-Ju2JTNSPB1BvMWghV-voMRNFCTsrCNRIjmGRDFc/edit?usp=sharing',
                    children: [
                        {
                            text: 'Indigo’s Publication Venue Database',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                            bold: true,
                        },
                    ],
                    id: 'nj4zr',
                },
                {
                    text: '.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'mooa6',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Confirm the student’s first and second choice venue.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: '2pz1m',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'If your student decides to submit their work to a venue not in our database, email ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    target: '_blank',
                    type: 'a',
                    url: 'mailto:hello@indigoresearch.org',
                    children: [
                        {
                            text: 'hello@indigoresearch.org',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: '7s53e',
                },
                {
                    text: ' so that we can add it.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'qqd7x',
        },
        {
            children: [
                {
                    text: 'For Explorer students, if there are no more hours left  in the package, ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'and your student would like publication support, please email ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    target: '_blank',
                    type: 'a',
                    url: 'mailto:hello@indigoresearch.org',
                    children: [
                        {
                            text: 'hello@indigoresearch.org',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'f3pxn',
                },
                {
                    text: '. ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            type: 'p',
            id: '5yumk',
        },
        {
            type: 'p',
            children: [
                {
                    text: '',
                },
            ],
            id: 'jbpwj',
        },
        {
            type: 'p',
            children: [
                {
                    text: '',
                },
            ],
        },
    ],
    'Checkpoint 10: Earn UCSB Credit at our Conference': [
        {
            type: 'p',
            children: [
                {
                    text: 'If your student has not purchased college credit, ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'skip this checkpoint.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'zgct0',
        },
        {
            type: 'p',
            children: [
                {
                    text: '\n',
                },
            ],
            id: 'i7a0o',
        },
        {
            type: 'p',
            children: [
                {
                    text: 'If your student has purchased college credit,',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: ' please complete this checkpoint to ensure that they are properly registered for Indigo’s Conference.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: '8s414',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Review these ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1Et6_TSGCiCQcA8ZoxICrzCbaY8U2WbCB87RCQPQ3Xyg/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: 'Conference Guidelines',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                            bold: true,
                        },
                    ],
                    id: 'q8fdn',
                },
                {
                    text: ' together,',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: ' including the checklist of materials to make.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'cdhud',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'The student should create and practice presenting  a 10-minute Conference PowerPoint presentation',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: '. ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'khkbt',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'You can support them using this ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    type: 'a',
                    url: 'https://docs.google.com/presentation/d/19m6xmSAGEAX8bUkArqI8HFsgtE7qvycWfs1yGsjtwDM/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: 'pre-written lecture',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                            bold: true,
                        },
                    ],
                    id: 'qqrhy',
                },
                {
                    text: ' ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'on how to prepare for a stellar academic talk.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'hm5e8',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Ask your student to practice their presentation on your Zoom call.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'e3xzl',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Please use ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1fPJGftnj_R_PlhLDMsSzABgATqEA8VjsRvXCJrC6xgg/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: 'this feedback form',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                            bold: true,
                        },
                    ],
                    id: 'k7jyh',
                },
                {
                    text: ' to offer constructive comments on their presentation.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'wagbu',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Guide your student to draft an abstract',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: ' ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: 'and bio',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: ' for the Conference using ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1sJ9rEmvEIdXPK48U7BDMACGrA7yFkOSH4YBeit3VDFw/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: 'this list of best practices',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                            bold: true,
                        },
                    ],
                    id: 'nysli',
                },
                {
                    text: '.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'lso0c',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 4,
            children: [
                {
                    text: 'Help your student submit this ',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 0)',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    type: 'a',
                    url: 'https://form.typeform.com/to/ARPav3Hq',
                    target: '_self',
                    children: [
                        {
                            text: 'Checkpoint 10 Conference Sign-Up Form',
                            fontSize: '11pt',
                            backgroundColor: 'rgb(255, 255, 0)',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                            bold: true,
                        },
                    ],
                    id: '2aw4y',
                },
                {
                    text: ' on your call. ',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 0)',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'q1bc7',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'If your student has purchased college credit, they ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: 'must',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    underline: true,
                    bold: true,
                },
                {
                    text: ' complete this form.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'o6ws8',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Your student will not earn college credit if they do not register for and attend one of Indigo’s quarterly Conferences.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: '418at',
        },
        {
            type: 'p',
            children: [
                {
                    text: '',
                },
            ],
            id: 'dabrk',
        },
        {
            type: 'p',
            children: [
                {
                    text: '',
                },
            ],
            id: '25jne',
        },
        {
            type: 'p',
            children: [
                {
                    text: '',
                },
            ],
        },
    ],
    'Checkpoint 11: Publication or Sharing Decision': [
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Guide the student to make any final edits,',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: ' using their PlagScan report and your comments.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'e0p8t',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Fill out Indigo’s ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/179BfPf0WcsRcS3FhpXIMA5pXRtQeYTekp6yG5LbFH-M/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: 'Path to Publication Form',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                            bold: true,
                        },
                    ],
                    id: 'htphp',
                },
                { text: ' using our ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true },
                {
                    type: 'a',
                    url: 'https://docs.google.com/spreadsheets/d/1Ht9-Ju2JTNSPB1BvMWghV-voMRNFCTsrCNRIjmGRDFc/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: 'Publication Venue Database',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                            bold: true,
                        },
                        { text: '.', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true },
                    ],
                    id: 'jczoa',
                },
                { text: '' },
            ],
            id: 'kbelb',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Prepare for the peer review process:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'geymq',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                { text: 'Read our ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1Jk3VhlGVSCJuKwX3F-IZ2kNUT5EXzZ0J/edit?usp=sharing&ouid=106164532408449283197&rtpof=true&sd=true',
                    target: '_blank',
                    children: [
                        {
                            text: 'sample review rubric',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'p8fub',
                },
                { text: '.', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
            ],
            id: 'w83hr',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'If your student could benefit from a review from another mentor, email ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: 'hello@indigoresearch.org',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(17, 85, 204)',
                    underline: true,
                },
                { text: '.', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
            ],
            id: 'bt9e7',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'If your student wants to learn from past students’ projects, check out our ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    type: 'a',
                    url: 'https://docs.google.com/spreadsheets/d/1C0iUeuFSk6UhRPC5FjUVDlO_O0s0_J4CvRmdQe48kk8/edit#gid=0',
                    target: '_blank',
                    children: [
                        {
                            text: 'Paper Database',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'bgsgs',
                },
                { text: ' or go through ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
                {
                    type: 'a',
                    url: 'https://terra-docs.s3.us-east-2.amazonaws.com/IJHSR/Articles/volume5-issue6/IJHSR_2023_56.pdf',
                    target: '_blank',
                    children: [
                        {
                            text: 'this IJHSR issue',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: '8xdf1',
                },
                {
                    text: ', which features work by Indigo students only. ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: '38pgz',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 4,
            children: [
                {
                    text: 'Indigo sometimes partners with journals.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                { text: ' Email ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
                {
                    text: 'hello@indigoresearch.org',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(17, 85, 204)',
                    underline: true,
                },
                { text: ' to learn more.', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
            ],
            id: 'x54mj',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 5,
            children: [
                {
                    text: 'If your student is an Explorer, and they are out of hours, they have a choice:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'bx6dn',
        },
        {
            type: 'p',
            listStyleType: 'decimal',
            indent: 1,
            children: [
                {
                    text: 'The student can purchase additional hours for publication support. Email ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: 'hello@indigoresearch.org',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(17, 85, 204)',
                    underline: true,
                },
                {
                    text: ', and then complete both Checkpoints 11 and 12.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'dsay1',
        },
        {
            type: 'p',
            listStyleType: 'decimal',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'If the student decides not to purchase these hours, you can skip to Checkpoint 12. Rest assured that you’ve already helped your student towards their publication goal by filling out the final feedback form at Checkpoint 9. ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'wjorn',
        },
        { type: 'p', children: [{ text: '' }], id: 'vyk0a' },
        { type: 'p', children: [{ text: '' }] },
    ],
    'Checkpoint 12: Documenting Outcomes': [
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Upload the final paper to the Crimson App. ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Navigate to the student’s Crimson App profile by clicking their name on your current list of students. ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Hover over “Student Center” and select “Academics.”',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Scroll to “Academic Research and “Publications,” where you should see Indigo as a “Program Provider.”',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [
                {
                    text: 'Click “Upload” and mark whether your student is pursuing publication.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'If the publication venue or conference that your student chose  is not in our database,',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                { text: ' share it with us (', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
                {
                    text: 'hello@indigoresearch.org',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(17, 85, 204)',
                    underline: true,
                },
                { text: ').', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Remind the student to let you know whether they get to publish or present their paper.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'If the paper is published, presented at a conference, or places in a competition, let us know (',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: 'hello@indigoresearch.org',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(17, 85, 204)',
                    underline: true,
                },
                { text: ').', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'If the paper is rejected, and the student wants to  purchase publication support hours, email ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: 'hello@indigorearch.org',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(17, 85, 204)',
                    underline: true,
                },
                { text: '.', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Set a calendar reminder to email your student 6 months from now, just in case your student doesn’t remember to email you. ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                { text: ' ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [
                {
                    text: 'You will earn a bonus by reporting your student’s outcome!',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        { type: 'p', children: [{ text: '' }] },
    ],
};
exports.INDIGO_RESEARCHER_TEMPLATES = {
    ...exports.INDIGO_INNOVATOR_TEMPLATES,
    'Checkpoint 6: Creating an Outline': [
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Choose one of Indigo’s outline templates.',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'iru36',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                { text: '' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/14RnoZjOi8OUx0nb_6OshGdQkmMi1pXugoFzW0Ql_NeA/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: ' Review Paper Outline Template',
                            fontSize: '11pt',
                            backgroundColor: 'rgb(255, 255, 255)',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'qflcw',
                },
                { text: '' },
            ],
            id: 'umqkm',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                { text: '' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/13ueWS5n2x2o1fi9MKRjncJRvbjOSXOXdbhtF_Oo8Zdg/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: ' Empirical Paper Outline Template',
                            fontSize: '11pt',
                            backgroundColor: 'rgb(255, 255, 255)',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 't64ji',
                },
                { text: '' },
            ],
            id: 'yxkw5',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                { text: '' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1PysEd6Lx_yEkQ2inLogSFdQT-jhD7FX5lsBkvAU31xc/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: ' Humanities & Social Sciences Outline Template',
                            fontSize: '11pt',
                            backgroundColor: 'rgb(255, 255, 255)',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'm0qo3',
                },
                { text: '' },
            ],
            id: 't1csm',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [
                { text: '' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1K4cusolxwYmYhRTaM31iWL-73LN38E0lgpdKk_rnhaI/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: ' Blog Post & Science Communication Article Outline Template',
                            fontSize: '11pt',
                            backgroundColor: 'rgb(255, 255, 255)',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'kcd7o',
                },
                { text: '' },
            ],
            id: 'p61jd',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 5,
            children: [
                { text: '' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1P5VMLlQQ9HoUU1ZiCOC_Y2Og_vJidft56qrGFaLUE0w/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: ' Short Academic Paper (1000-2000 words) Outline Template',
                            fontSize: '11pt',
                            backgroundColor: 'rgb(255, 255, 255)',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'y7nj3',
                },
                { text: '' },
            ],
            id: 'oz24w',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Make a copy, edit it to fit your field, and customise it to fit the student’s project.',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'bs9qd',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'For projects with a creative outcome (e.g., a portfolio, invention, or creative writing) create your own outline.',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'g1dkb',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Consider sharing your customised outline with the Indigo team (',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: 'hello@indigoresearch.org',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(17, 85, 204)',
                    underline: true,
                },
                { text: '). ', fontSize: '11pt', backgroundColor: 'rgb(255, 255, 255)', color: 'rgb(0, 0, 0)' },
            ],
            id: 'qt2w0',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Review the outline together,',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                { text: ' ', fontSize: '11pt', backgroundColor: 'rgb(255, 255, 255)', color: 'rgb(0, 0, 0)' },
                {
                    text: 'address any questions, and agree on a timeline for this checkpoint.',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'l2jyv',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Consider scheduling occasional half-hour check-in calls instead of hour long calls to allow for more time for writing in the package.',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: '0k36l',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'At this point in the project, Indigo is not expecting you to meet for an hour every week, but we do want you to be in communication every week.',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'bs17z',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 4,
            children: [
                {
                    text: 'For empirical papers, guide the student to begin their data collection.',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: '6haux',
        },
        { type: 'p', children: [{ text: '' }], id: 'vyk0a' },
        { type: 'p', children: [{ text: '' }] },
    ],
};
exports.INDIGO_EXPLORER_TEMPLATES = {
    ...exports.INDIGO_RESEARCHER_TEMPLATES,
    'Checkpoint 2: Defining Your Research': [
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Set these expectations with your student:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'jusp6',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Their Indigo project will conclude with a concrete outcome, such as a final paper.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'ogu1q',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'You will aim  to share their research with a scholarly community through a journal, competition, conference, or alternative publication venue.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'gsi0o',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'However, the purpose of this project is to ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                { text: 'explore', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', italic: true },
                {
                    text: ' your field, and it will be okay if it is not possible to publish the paper within the timeframe of the Explorer package.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: '1uiz0',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [
                {
                    text: 'You will agree on a research topic early on, but the research question may grow more specific and nuanced over the course of your collaboration.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: '7csep',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Explore potential Indigo Project Outcomes!',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'dsyxp',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                { text: 'Look through our ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/spreadsheets/d/1Ht9-Ju2JTNSPB1BvMWghV-voMRNFCTsrCNRIjmGRDFc/edit#gid=0',
                    target: '_blank',
                    children: [
                        {
                            text: 'Publication Venue Database',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'nm7vr',
                },
                {
                    text: ' to see a selection of the scholarly conversations the student could enter. Treat these as inspiration and motivation!',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: '6dzma',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                { text: 'Skim our ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/spreadsheets/d/1C0iUeuFSk6UhRPC5FjUVDlO_O0s0_J4CvRmdQe48kk8/edit#gid=0',
                    target: '_blank',
                    children: [
                        {
                            text: 'Project Database',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'zne0h',
                },
                {
                    text: ' of past students’ work for inspiration.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'z3c0c',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                { text: 'Peruse our ', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/spreadsheets/d/1Np_hTMa7kdCXFEZhaNqqo_vOcBDKA5h_qugZPgGqucc/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: 'Research Question Database',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'q5hqp',
                },
                {
                    text: ' to learn about the scope and form of a research question in your field.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'rzfjc',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Agree on a realistic project outcome as well as a preliminary question or topic.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'fbk1n',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 4,
            children: [
                {
                    text: 'Best Practices:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: '2g4w6',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Don’t agree to a topic or research outcome that will require the student to gain access to facilities, equipment, and/or a skill set that is not realistic.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: '3g1ol',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'If you select a question from our Database, email ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: 'hello@indigoresearch.org',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(17, 85, 204)',
                    underline: true,
                },
                { text: '.', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
            ],
            id: 'jg902',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'If the student uses GPT or our database to find a question, they will still have to make that question their own, revising it to fit their research interests as they learn more.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'd03r7',
        },
        { type: 'p', children: [{ text: '' }], id: 'vyk0a' },
        { type: 'p', children: [{ text: '' }] },
    ],
    'Checkpoint 6: Creating an Outline': [
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Choose one of Indigo’s outline templates.',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'z0zal',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                { text: '' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/14RnoZjOi8OUx0nb_6OshGdQkmMi1pXugoFzW0Ql_NeA/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: ' Review Paper Outline Template',
                            fontSize: '11pt',
                            backgroundColor: 'rgb(255, 255, 255)',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: '4h0jd',
                },
                { text: '' },
            ],
            id: 'vsr9j',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                { text: '' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/13ueWS5n2x2o1fi9MKRjncJRvbjOSXOXdbhtF_Oo8Zdg/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: ' Empirical Paper Outline Template',
                            fontSize: '11pt',
                            backgroundColor: 'rgb(255, 255, 255)',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'modgz',
                },
                { text: '' },
            ],
            id: 'vnzik',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                { text: '' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1PysEd6Lx_yEkQ2inLogSFdQT-jhD7FX5lsBkvAU31xc/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: ' Humanities & Social Sciences Outline Template',
                            fontSize: '11pt',
                            backgroundColor: 'rgb(255, 255, 255)',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: '1px7k',
                },
                { text: '' },
            ],
            id: 'zc0hh',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [
                { text: '' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1K4cusolxwYmYhRTaM31iWL-73LN38E0lgpdKk_rnhaI/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: ' Blog Post & Science Communication Article Outline Template',
                            fontSize: '11pt',
                            backgroundColor: 'rgb(255, 255, 255)',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'kyt2t',
                },
                { text: '' },
            ],
            id: '2mhnw',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 5,
            children: [
                { text: '' },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1P5VMLlQQ9HoUU1ZiCOC_Y2Og_vJidft56qrGFaLUE0w/edit?usp=sharing',
                    target: '_blank',
                    children: [
                        {
                            text: ' Short Academic Paper (1000-2000 words) Outline Template',
                            fontSize: '11pt',
                            backgroundColor: 'rgb(255, 255, 255)',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                    id: 'fol9a',
                },
                { text: '' },
            ],
            id: 'wcgfz',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Make a copy, edit it to fit your field, and customise it to fit the student’s project.',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'tz1uy',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'For projects with a creative outcome (e.g., a portfolio, invention, or creative writing) create your own outline.',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'pkgzo',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Consider sharing your customised outline with the Indigo team (',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: 'hello@indigoresearch.org',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(17, 85, 204)',
                    underline: true,
                },
                { text: '). ', fontSize: '11pt', backgroundColor: 'rgb(255, 255, 255)', color: 'rgb(0, 0, 0)' },
            ],
            id: 'vxn0y',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Review the outline together,',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                { text: ' ', fontSize: '11pt', backgroundColor: 'rgb(255, 255, 255)', color: 'rgb(0, 0, 0)' },
                {
                    text: 'address any questions, and agree on a timeline for this checkpoint.',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'ubf7n',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'At this point in the project, please plan to meet for a half hour at most every week, to allow more time for writing before the hours in the project elapse.',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: 'gc7vo',
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'While Indigo does not advise you to meet for a full hour every week, please continue to communicate about your research with each other every week, even if only over email.',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                },
            ],
            id: '1dps0',
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 4,
            children: [
                {
                    text: 'For empirical papers, guide the student to begin their data collection.',
                    fontSize: '11pt',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
            id: 'd1iix',
        },
        { type: 'p', children: [{ text: '' }], id: 'vyk0a' },
        { type: 'p', children: [{ text: '' }] },
    ],
};
//# sourceMappingURL=indigo.js.map